<script lang="ts" setup>
import { projectService } from '@/services/project/project-service';
import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import ProjectOrganisations from '../ProjectOrganisations.vue';
import type {
  ProjectOrganisationsActionEvent,
  ProjectOrganisationsProps,
} from '../types';
import ProjectOrganisationsSkeleton from './ProjectOrganisationsSkeleton.vue';

const props = defineProps<{
  projectId: string;
}>();

const emit = defineEmits<{
  action: [event: ProjectOrganisationsActionEvent];
}>();

const organisationQuery = useQuery({
  queryKey: computed(() => [
    'projectService',
    'getProjectOrganisations',
    props.projectId,
  ]),
  queryFn: async () =>
    await projectService.getProjectOrganisations(props.projectId),
});

const data = computed<ProjectOrganisationsProps>(() => ({
  projectId: props.projectId,
  organisations:
    organisationQuery.data.value?.map((organisation) => ({
      ...organisation,
      name: organisation.name ?? undefined,
      stakeholders: organisation.stakeholders.map((stakeholder) => ({
        ...stakeholder,
        userId: stakeholder.userId ?? undefined,
        email: stakeholder.email ?? undefined,
        phone: stakeholder.phone ?? undefined,
        role: stakeholder.role ?? undefined,
        name: stakeholder.name ?? undefined,
      })),
    })) ?? [],
}));
</script>

<template>
  <ProjectOrganisationsSkeleton v-if="organisationQuery.isPending.value" />
  <ProjectOrganisations
    v-else
    v-bind="data"
    @action="(event) => emit('action', event)"
  />
</template>
